/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUser, UserState } from './auth';

const initialState: UserState = {
  isAuthenticated: false,
  isVerified: false,
  user: null,
  isLoading: true,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.isVerified = action.payload.isVerified;
      state.isLoading = false;
    },
    setLogout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.isVerified = false;
      state.isLoading = true;
    },
    setUserDataLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setCredentials, setLogout, setUserDataLoading } =
  authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state: { auth: UserState }) => state.auth;

export const selectUserId = (state: { auth: UserState }): string => {
  if (state.auth.isAuthenticated && state.auth.user) {
    return state.auth.user._id;
  }
  return '';
};
